import jsonLogic from 'json-logic-js';
import { QuestionI } from 'base/types';

export const isQuestionVisible = (
  question: QuestionI,
  compareObject: object
) => {
  return jsonLogic.apply(question.conditions, compareObject);
};
